import {TRANSFERRED} from 'src/shared/channelTracking/constants/actionIds';
import {SUCCESS} from 'src/shared/channelTracking/constants/status';
import {UNKNOWN} from 'src/shared/channelTracking/constants/interactionType';
import {EINSTEIN_360} from 'src/shared/channelTracking/constants/channel';

export const viewSuccess = {
  action: {
    id: TRANSFERRED,
    status: SUCCESS,
    metadata: {
      targetChannel: EINSTEIN_360,
    },
  },
  interactionType: UNKNOWN,
  eventTimestamp: Date.now().toString(),
};
